import React from 'react';
import { Droppable } from 'react-beautiful-dnd';
import Loader from '4all-ui/components/Loader';
import VariationDragDropItem from '../VariationDragDropItem';
import * as styles from '../ProductVariationColumn/style';
import * as GenericStyles from '../../../styles/StyledComponents/GenericList';
import GenericListHeader from '../../GenericListHeader';
import withVariations from '../../../containers/GlobalVariations';
import {
  VARIATION_DRAG_DROP_COLUMNS,
  PRODUCT_CREATION_VARIATION_TYPE,
} from '../../../helpers/constants';
import { filterVariationOptions } from '../../../helpers/search';

class GlobalVariationColumn extends React.Component {
  state = { searchText: '' };

  componentDidUpdate(prevProps) {
    if (
      prevProps.variations.length > 0 &&
      this.props.variations.length !== prevProps.variations.length
    ) {
      let newVariationId = this.props.variations.map(variation => variation.id).pop();
      this.scrollToNewVariation(newVariationId);
    }
  }

  scrollToNewVariation = elem => {
    if (this[`item_${elem}`]) {
      this[`item_${elem}`].scrollIntoView({ behavior: 'smooth' });
    }
  };

  componentDidMount() {
    this.props.getVariations();
  }

  handleChange = e => {
    this.setState({ searchText: e.target.value });
  };

  filterOptions = () => {
    const variations = this.props.variations.filter(
      variation => !this.props.items.some(item => item.id === variation.id)
    );

    return filterVariationOptions(this.state.searchText, variations);
  };

  setRef = (name, node) => {
    this[name] = node;
  };

  buttonClick = () => {
    const { onClickVariationActions, setTypeOfNewVariation } = this.props;
    onClickVariationActions();
    setTypeOfNewVariation(PRODUCT_CREATION_VARIATION_TYPE.global);
  };

  render() {
    const filteredOptions = this.filterOptions();
    const { isLoadingVariations, isDraggingOver } = this.props;

    return (
      <styles.Container>
        <GenericListHeader
          id={`${VARIATION_DRAG_DROP_COLUMNS.GLOBAL_VARIATIONS}-search`}
          title="Variações Globais"
          desc="Clique e arraste as variações globais para fazer parte do seu produto."
          search
          onChange={this.handleChange}
          searchText={this.searchText}
          searchPlaceholder="Selecione"
          searchInputSize="100%"
          button
          buttonId="new-global-variation-btn"
          buttonText="Criar Variação Global"
          buttonOnClick={this.buttonClick}
        />

        <styles.DroppableContainer>
          {isLoadingVariations ? (
            <GenericStyles.LoaderContainer customStyles={{ marginTop: '90px' }}>
              <Loader size="60px" />
            </GenericStyles.LoaderContainer>
          ) : (
            <Droppable
              droppableId={VARIATION_DRAG_DROP_COLUMNS.GLOBAL_VARIATIONS}
              isDropDisabled
              className="droppable"
            >
              {provided => (
                <styles.ItemList ref={provided.innerRef} {...provided.droppableProps}>
                  {filteredOptions.map((item, index) => (
                    <VariationDragDropItem
                      key={item.id}
                      item={item}
                      index={index}
                      setRef={this.setRef}
                      showActions={false}
                      isDraggingOver={isDraggingOver}
                    />
                  ))}

                  {filteredOptions.length === 0 && (
                    <styles.StyledEmptyMessage big>
                      Não há variações disponíveis
                    </styles.StyledEmptyMessage>
                  )}

                  {provided.placeholder}
                </styles.ItemList>
              )}
            </Droppable>
          )}
        </styles.DroppableContainer>
      </styles.Container>
    );
  }
}

export default withVariations(GlobalVariationColumn);



// WEBPACK FOOTER //
// ./src/components/VariationDragDrop/GlobalVariationColumn/index.js